function questionMatcher(row, selectedValue) {
    return selectedValue && (row?.additionalInfo?.[selectedValue] !== undefined);
}

function answerMatcher(row, selectedValue) {
    return selectedValue && row?.additionalInfo &&
        (Object.entries(row.additionalInfo).findIndex(([_, answer]) => answer === selectedValue) !== -1);
}

export { questionMatcher, answerMatcher };